export const checkProvided = (value?: unknown) =>
  !value ? 'Must be provided' : undefined;
